export default {
  app: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/layouts/app.vue").then(m => m.default || m),
  blank: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/layouts/default.vue").then(m => m.default || m)
}